import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 22 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 11C0 4.92 4.92 0 11 0s11 4.92 11 11-4.92 11-11 11S0 17.08 0 11",
  style: {"fill":"#077401","fill-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M16.32 7.03a1 1 0 0 0-.69-.28h-.01c-.27 0-.51.11-.7.3l-5.66 5.79-2.18-2.23a.98.98 0 0 0-.7-.3c-.27 0-.52.1-.71.28a.993.993 0 0 0-.02 1.4l2.89 2.96c.19.19.45.3.71.3s.52-.11.71-.3l6.37-6.51a.98.98 0 0 0 .28-.71c0-.27-.11-.51-.3-.7Z",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }